import common from "./common";
import supply from "./supply";

export default { common, supply };
